import { trigger, style, state, transition, animate } from '@angular/animations';

const openClose = trigger('openClose', [
  state('open', style({
    width: '100%',
    height: '100%',
    bottom: '0rem',
    right: '0rem',
    borderRadius: '0%',
    backgroundColor: 'white'
  })),
  state('closed', style({
    width: '4rem',
    height: '4rem',
    bottom: '1rem',
    right: '1rem',
    borderRadius: '50%'
  })),
  transition('open => closed', [
    animate('0.3s')
  ]),
  transition('closed => open', [
    animate('0.2s')
  ]),
]);

const popUp = trigger('popUp', [
  state('showPopUp', style({
    transform: 'scale(1)',
    backdropFilter: 'blur(3px)'
  })),
  state('hiddePopUp', style({
    transform: 'scale(0)',
    backdropFilter: 'blur(0px)'
  })),
  transition('showPopUp => hiddePopUp', [
    animate('0.4s')
  ]),
  transition('hiddePopUp => showPopUp', [
    animate('0.4s')
  ]),
]);

export { openClose, popUp }